import { STATUS } from "./usePickerCore";

/**
 *
 * @param dispatch
 * @returns {function(...[*]=)}
 */
export const useCallerHandler = (dispatch) => async (type, callback) => {
    try {
        dispatch({type, status: STATUS.FETCH});
        const payload = await callback();
        if(payload.messages && payload.messages.length > 0) {
            return dispatch({type, status: STATUS.FAILURE, payload: payload})
        }
        dispatch({type, status: STATUS.SUCCESS, payload});
    } catch (e) {
        console.log('useCallerHandlerError', e);
        dispatch({type, status: STATUS.FAILURE, payload: e})
    }
};